import { DataGrid } from "@mui/x-data-grid";
import { activeSubColumns } from "../../datatablesource";
import { useEffect, useState } from "react";

import { fetchUrl } from "../../../../functions/fetchUrl";

const ActiveSubTimWe = ({ table }) => {
  useState("Loading...");

  console.log("tablename endpoint: " + table)
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    setData([]);
    const fetchData = async () => {
      const response = await fetchUrl({ apiName: table, method: "get" });
      if (response.success) {
        setData(response.result);
      }
    };
    fetchData();
  }, [table]);

  // console.log(columns);
  useEffect(() => {
    setColumns([])
    if (table === "stylistsa/SA" || table === "stylistkw/KW") {
      const aistylistSubColumns = [
        {
          field: "numb",
          headerName: "numb",
          width: 130,
        },

        {
          field: "message",
          headerName: "message",
          width: 140,
        },
        {
          field: "subscribed_at",
          headerName: "subscribed_at",
          width: 150,
        }
      ];

      setColumns(aistylistSubColumns)
    } else if (table === "katcha/SA") {
      const aistylistSubColumns = [
        {
          field: "numb",
          headerName: "numb",
          width: 130,
        },
        {
          field: "datetime",
          headerName: "subscribed_at",
          width: 190,
        }
      ];

      setColumns(aistylistSubColumns)
    } else {
      setColumns(activeSubColumns)
    }
  }, [table])

  return (

    <>
      <DataGrid
        className="ml-1"
        rows={data}
        columns={columns}
        pageSize={15}
        rowsPerPageOptions={[5]}
        style={{ height: "60vh" }}
        getRowId={(data) => data.id}
      />
    </>

  );
};

export default ActiveSubTimWe;
